import { FormControl, InputLabel, MenuItem, Select } from '@mui/material'
import { useTranslation } from 'react-i18next'

import { PAGE_SELECT_OPTIONS } from '../../../../../utils/params/helpers'

const PageForm = ({ outlinedInput, currentPath, onChangeCurrentPath }) => {
	const { t } = useTranslation('common')

	return (
		<>
			<FormControl
				variant={outlinedInput ? 'outlined' : 'standard'}
				sx={{ my: outlinedInput ? 0 : 1, minWidth: outlinedInput ? '50%' : '100%' }}
				size={outlinedInput ? 'small' : 'medium'}
			>
				<InputLabel id="view-select-small-label">{t('common:input.view')}</InputLabel>
				<Select
					labelId="view-select-small-label"
					id="view-select-small"
					value={currentPath}
					label={t('common:input.view')}
					onChange={(e) => {
						onChangeCurrentPath(e.target.value)
					}}
				>
					<MenuItem value="">
						<em>None</em>
					</MenuItem>
					{PAGE_SELECT_OPTIONS.map((menu) => (
						<MenuItem value={menu?.page?.path} key={menu?.page?.path}>
							{menu.name}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</>
	)
}

export default PageForm
